import { render, staticRenderFns } from "./GvdManageResources.vue?vue&type=template&id=49b241c1"
import script from "./GvdManageResources.vue?vue&type=script&lang=ts"
export * from "./GvdManageResources.vue?vue&type=script&lang=ts"
import style0 from "./GvdManageResources.vue?vue&type=style&index=0&id=49b241c1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports